import { UserRoleDTO } from 'models'

export interface UserRequest {
  id?: number
  emailAddress: string
  password?: string
  newPassword?: string
  parentOrganizationId?: number
  organizationId: number
  organizationName?: string
  firstName?: string
  lastName?: string
  skipInvitationEmail?: boolean
  roles: UserRoleDTO[]
}

export enum LinkTo {
  PERSON = 'person',
  STORE = 'store'
}

export const viewerRoleId = 7
export const shopOwnerRoleId = 6
export const personEditRoleId = 9

export const roleIdsWithNoProjectsAssignmentOption = [
  viewerRoleId,
  shopOwnerRoleId,
  personEditRoleId
]
